/* eslint-disable */
import Vue from 'vue';

import axios from 'axios';
import VueMeta from 'vue-meta';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import Quill from 'quill';
import VueQuill from 'vue-quill';
import ImageResize from 'quill-image-resize-module';

import 'element-ui/lib/theme-chalk/index.css';

import App from './App.vue';
import router from './router';
import API_URLs from './utils/network';
import iconsConfig from './components/Icons/AppIcons';


Quill.register('modules/ImageResize', ImageResize);
iconsConfig(Vue);


Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.use(VueQuill);
Vue.use(ElementUI, {locale});
Vue.use(VueMeta, {refreshOnceOnNavigation: true});

Vue.mixin({
  data() {
    return {
      // apiURL: API_URLs.API_URL,
    }
  },
  methods: {
    refreshTokenExpirationCountUp(timestamp) {
      let timeDiff = timestamp - (Date.now() / 1000 | 0);
      return setTimeout(callback, (timeDiff * 1000));
    }
  },
  computed: {
    apiURL() {
      return API_URLs.API_URL;
    }
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
